import {BasePanelPage} from "../../../../PanelPage";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {SubscribeSuccessPanelStyle} from "../SubscribeSuccessPanel.jsx";
import {Messages} from "../../../../../Messages";
import {SubscriptionCoveragePerk} from "../components/CoverageDescriptionElements";
import {HappyFaceIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {dismissFlowSuccess} from "../../../../../widget/misc/WidgetUtils";
import {PromptManageAccountButton} from "../../../../panel-elements/LoginFooter.jsx";


@registerStyle(SubscribeSuccessPanelStyle)
export class GiftSubscriptionSuccessPanel extends BasePanelPage {
    getGuidelines() {
        return [
            <SubscriptionCoveragePerk text={Messages.giftSubscriptionSuccessGuideline1}/>,
            <SubscriptionCoveragePerk text={Messages.giftSubscriptionSuccessGuideline2}/>,
        ]
    }

    render() {
        const {styleSheet} = this;

        return [
            <HappyFaceIcon className={styleSheet.icon}/>,
            <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                {Messages.giftSubscriptionSuccessTitle}
            </div>,
            <div className={styleSheet.message}>{Messages.giftSubscriptionSuccessText}</div>,
            this.getGuidelines(),
            <MerchantButton onClick={dismissFlowSuccess} className={styleSheet.actionButton}>
                {Messages.ok}
            </MerchantButton>,
            <PromptManageAccountButton className={styleSheet.backButton} />
        ];
    }
}
